import Vue     from 'vue';
import {copyObj, copyArr, getKey, isNull} from './urDataGridUtil';
import {CONST} from '../config';

let DS_IDX = 0;

/**********************************************/
/**** DataSet 객체입니다.                  ****/
/**********************************************/
class DataSet {
    // this.rawData
    // this.data
    // this.viewData
    // this.updated
    // this.dataUpdated
    
    // this.totlaSize
    // this.dataSize
    // this.viewSize
    
    // this.dataMap
    // this.keyField
    // this.selLen
    
    // this.changed : {created : [], updated : [], removed : []}
    /**
     * [CONSTRUCTOR] 생성자!
     * @param data Data for set
     * @param opts Data options 
     */ 
    constructor(origin) {
        // 0. init member variable
        // 0.1 set virtual - avoid vue reactive
        let rawData, data, viewData, selected=[], dataMap=new Map();
        let changed = {created : [], updated : [], removed : []};
        Object.defineProperty(this,'rawData' ,{configurable:false, get : () => rawData , set : (v) => rawData=v})
        Object.defineProperty(this,'data'    ,{configurable:false, get : () => data    , set : (v) => data=v})
        Object.defineProperty(this,'viewData',{configurable:false, get : () => viewData, set : (v) => viewData=v})
        Object.defineProperty(this,'selected',{configurable:false, get : () => selected, set : (v) => selected=v})
        Object.defineProperty(this,'dataMap' ,{configurable:false, get : () => dataMap})
        Object.defineProperty(this,'changed' ,{configurable:false, get : () => changed})
        // 0.2 Set initial value - below will be reactive
        this.dsIdx = DS_IDX++;
        this.totalSize = 0;
        this.dataSize  = 0;
        this.viewSize  = 0;
        this.selLen    = 0;
        this.isGroup = false;
        // 0.3 updated
        this.updated     = 0;
        this.dataUpdated = 0;
        // 1. Check constructor args & Set data
        this.setData(origin || []);
    }
    /**
     * [METHOD*][DATA] Set data
     * Replace all data(raw/all)
     * @param data Data for set 
     */
    setData(data) {
        // 1. Set raw data
        this.rawData = data || [];
        // 2. Set additional info
        this.dataMap.clear()
        this.rawData.forEach(this.initRow, this);
        // 3. post process
        // 3.1 data size
        this.totalSize = this.rawData.length;
        // 4. Reset
        // 4.1 Reset dirty array
        this.changed.created = [];
        this.changed.updated = [];
        this.changed.removed = [];
        // 4.2 Reset selected row
        this.selected = [];
        this.updateSelectLength()
        // x. emitUpdate?
        this.dataUpdate();
    }
    /**
     * [METHOD*][DATA] Append data
     * Append data to previous (raw/all)
     * @param data Data for set
     */
    appendData(data) {
        // 1. Set raw data(*)
        this.rawData.push(...data);
        // 2. Set additional info
        this.dataMap.clear()
        this.rawData.forEach(this.initRow, this);
        // 3. post process
        // 3.1 data size
        this.totalSize = this.rawData.length;
        // x. emitUpdate?
        this.dataUpdate();
    }
    /**
     * [METHOD*][DATA] Unshift data
     * Append data to previous (raw/all)
     * @param data Data for set
     */
    unshiftData(data) {
        // 1. Set raw data(*)
        let tobe = [];
        tobe.push(...data);
        tobe.push(...this.rawData);
        this.rawData.length = 0;
        this.rawData.push(...tobe);
        tobe.length = 0;
        // 2. Set additional info
        this.dataMap.clear()
        this.rawData.forEach(this.initRow, this);
        // 3. post process
        // 3.1 data size
        this.totalSize = this.rawData.length;
        // x. emitUpdate?
        this.dataUpdate();
    }
    /**
     * [METHOD][DATA] Initialize row
     * make ID(& append to map)!!
     * & set other attribute
     */
    initRow(row, i) {
        // 1. set ID
        if(!row.__id) {
            row.__id  = getKey(`grid${this.dsIdx}`);
        }
        this.dataMap.set(row.__id, row); 
        /// 2. set Index :: do not use for logic
        row.__idx = i;
        if(!row.hasOwnProperty('__hover'))    { row.__hover     = false }
        if(!row.hasOwnProperty('__dirty'))    { row.__dirty     = '' } /* '' | 'C' | 'U' | 'D' */
        if(!row.hasOwnProperty('__selected')) { row.__selected  = false }
        if(!row.hasOwnProperty('__focused'))  { row.__focused  = false }
        if(!row.hasOwnProperty('__editMode')) { row.__editMode  = false }
        if(!row.hasOwnProperty('__editField')){ row.__editField =  null }
        if(!row.hasOwnProperty('__errMsg'))   { row.__errMsg    =  null }
        if(!row.hasOwnProperty('__accordion')){ row.__accordion = false }
        if(!row.hasOwnProperty('__active'))    { row.__active = false }
    }
    /**
     * [METHOD][DATA] Build data
     * copy data from origin to data
     * rawData -> [filter] -> [sort] -> data
     * The data(row?item?) is the same object(===) as rawData's one.
     */
    buildData(filterArr, sortArr) {
        var arr;
        // 1. Copy data from origin
        arr = this.rawData.slice();
        // 2. Filter first
        //    mxFullGridFilterMixin.js
        if(filterArr && filterArr.length) {
            arr = this.filterData(arr, filterArr);
        }
        // 3. Sort is second
        //    urFullGridSortMixin.js
        if(sortArr && sortArr.length) {
            arr = this.sortData(arr, sortArr);
        }
        // x. Set to this.data
        this.data = arr;
        this.dataSize = arr.length;
    }
    /**
     * [METHOD][DATA] Build group data
     * copy data from origin to data with group tree form
     * rawData -> [filter] -> [sort] -> data
     * The data(row?item?) is the same object(===) as rawData's one.
     */
    buildGroupData(group, filterArr, sortArr, filterGrp, sortGrp) {
        var oriArr = this.rawData.slice();
        var arr = [], rootMap = new Map(), me = this;
        
        // TODO 만약에.. 필터를 먼저한다면 어떨까? 백만배 빨라질까?
        //      필터 -> 분류 -> 정렬 -> PROFIT!!!?
        
        // 1. split data(from data origin)
        oriArr.forEach(row => {
            var obj = {children:arr, chMap:rootMap};
            group.forEach((grp,i) => {
                var v = row[grp];
                if(obj.chMap.has(v)) {
                    obj = obj.chMap.get(v);
                } else {
                    var nue = mx_newGroupObj(v,i);
                    obj.children.push(nue);
                    obj.chMap.set(v, nue);
                    obj = nue;
                }
            })
            // 1.x Found target object(group)
            obj.leaf = true
            obj.children.push(row);
        })
        
        // 2. Sort & filter array
        arr = (function subArr(origin, depth) { // recursive
            //var grps = group;
            /*var f = me.mx_fieldMap.get(grps[depth]);*/
            let list = origin.slice();
            // 1. Calc this.
            // 1.1 Filter me
            var f = filterGrp[depth];
            if(!isNull(f.data)) {
                list = list.filter(grp => f.checker(grp.value, f.data))
            }
            // 1.2 Sort me
            var s = sortGrp[depth];
            if(s.__sortOrder) {
                list.sort((x,y) => me.sortComparator(s,x,y,'value'))
            }
            // 1.x And iter children..
            list.forEach(o=>{
                if(o.leaf) {
                    // 1. Copy data from origin
                    var childs = o.children.slice();
                    // 2. Filter first
                    if(filterArr && filterArr.length) {
                        childs = me.filterData(childs, filterArr);
                    }
                    // 3. Sort is second
                    if(sortArr && sortArr.length) {
                        childs = me.sortData(childs, sortArr);
                    }
                    Object.defineProperty(o,'children', {get:()=>childs})
                    o.chLen = o.children.length;
                } else if(o.group) {
                    o.children = subArr(o.children, depth+1);
                    o.chLen = o.children.reduce((acc, ch)=>acc+ch.chLen,0);
                } else {
                    // Cannot approch here
                }
            })
            return list;
        })(arr, 0);
        
        // 3. set data
        this.data = arr;
        this.dataSize = arr.reduce((acc,data) => acc+data.chLen,0);
        this.isGroup = true;
        
        function mx_newGroupObj(v, i) {
            return {
                group : true,
                value : v    , depth : i,
                children : [], chMap : new Map(), chLen : 0,
                leaf  : false, expand: true,
                __st : 0     , __ed: 0
            }
        }
    }
    /**
     * [METHOD][DATA] Build view data
     * data -> [page slice] -> view data
     * is same as this.data or slice it
     * @return Return all data
     */
    buildViewData(pos) {
        if(!!pos) {
            // 1. if pagination
            this.viewData = this.data.slice(pos.st, pos.ed);
        } else {
            // 2. else -> bypass
            this.viewData = this.data.slice();
        }
        if(this.isGroup) {
            this.viewSize = this.viewData.reduce((acc,data) => acc+data.chLen,0);
        } else {
            this.viewSize = this.viewData.length;
        }
        // x. emit update
        this.emitUpdate();
    }
    /**
     * [METHOD][DATA] Build key map
     * @return Return all data
     */
    buildKeyMap(data) {
        this.dataMap.clear();
        this.rawData.forEach((v)=> {
            this.dataMap.set(v.__id, v)
        });
    }
    /**
     * [METHOD][DATA] Rebuild index
     * @return N/A
     */
    rebuildRowIdx() {
        this.rawData.forEach((row,i)=> {
            row.__idx = i;
        });
        // x. refresh
        // XXX 꼭 데이터-그리드 업데이트를 해야 할만큼 중요한 기능은 아님.
        //     누적된 업데이트를 한번만 하도록 하는 기능이 없다면...
        //     여기서 업데이트 빼고, 필요할때 수동으로 하는 기능 넣는게 좋아보임
        this.emitUpdate();
    }
    /**
     * [METHOD][DATA] Get viewing data
     * @return Return all data
     */
    getViewData() {
        return this.viewData;
    }
    /**
     * [METHOD][DATA] Get raw data
     * @return Return all data
     */
    getRawData() {
        return this.rawData;
    }
    /**
     * [METHOD*][DATA] Clear all data
     */
    clearData() {
        this.rawData  = [];
        this.viewData = [];
        this.emitUpdate();
    }
    /**
     * [METHOD][DATA] get row by key
     */
    getRow(key) {
        return this.dataMap.get(key);
    }
    /**
     * [METHOD+][EDIT] set row by key
     * @return that row
     */
    setRow(key, data) {
        // 1. find row
        let row = this.getRow(key);
        if(!row) {return null;}
        // 2. copyData
        Object.assign(row, data);
        // 3. set dirtyFlag
        if(!row.__dirty) {
            row.__dirty = CONST.VAL.DIRTY.FLAG.UPDATE;
            this.changed.updated.push(row);
        }
        // 4. updated..
        this.emitUpdate(row);
        return row;
    }
    /**
     * [METHOD+][EDIT] set row value by key
     */
    setRowValue(_key, field, value) {
        // 1. find row
        var key = _key;
        if(typeof key === 'object') {key = _key.__id}
        let row = this.getRow(key);
        if(!row) {return null;}
        // 2. copyData
        row[field] = value;
        // 3. set dirty
        if(!row.__dirty && (field[0]!=='_'||field[1]!=='_')) { // !field.startsWith('__')
            row.__dirty = CONST.VAL.DIRTY.FLAG.UPDATE;
            this.changed.updated.push(row);
        }
        // x. updated..
        this.emitUpdate(row, field);
        return row;
    }
    /**
     * [METHOD*][EDIT] Add data row
     * @param row Data for add row
     */
    addRow(row, idx) {
        // case 1. add to last
        // 0. prepare value
        let _row = copyObj(row), i=this.rawData.length;
        // 1. Append to Data
        if(idx === 0) {
            this.rawData.unshift(_row);
        } else if(!idx) {
            this.rawData.push(_row);
        } else {
            this.rawData.splice(idx,0,_row);
        }
        this.totalSize = this.rawData.length;
        // 2. set additional info
        // 2.1 init row
        this.initRow(_row, i);
        // 2.2 rebuild all row idx
        if(idx === 0 || !!idx) {
            this.rebuildRowIdx();
        }
        // 2.3 Dirty field & Dirty array
        _row.__dirty = CONST.VAL.DIRTY.FLAG.CREATE;
        this.changed.created.push(_row);
        
        // x. UPDATE!!
        this.dataUpdate()
    }
    /**
     * [METHOD*][EDIT] Add temporary row -> to viewData
     * @param Temporary object
     * @return Index of temp row..
     */
    addTempRow(row) {
        let _row = copyObj(row);
        this.initRow(_row, null);
        this.viewData.unshift(_row);
        this.viewSize = this.viewData.length;
        this.emitUpdate();
        return 0; // TODO set row to any position.
    }
    /**
     * [METHOD*][EDIT] Remove temporary row
     * @param Temporary object
     * @return Index of that row..
     */
    removeTempRow() {
        // 1. Find temp row
        // TODO update logic... something like Dirty field
        // 2. Remove temp row
        this.viewData.shift();
        this.emitUpdate();
        return 0; // INDEX?
    }
    /**
     * [METHOD*][EDIT] Reomve data row
     * @param row Data for add row
     */
    removeRow(row, selectNext) {
        // 0. pre-process
        var idx;
        if(selectNext) {
            idx = this.viewData.findIndex(d => d.__id === row.__id);
        }
        // 1. remove row
        this.removeRows([row]);
        // 2. selectNext?
        if(selectNext) {
            var next = this.viewData[idx+1] || this.viewData[idx-1]; // pick next or previous(if last row remove);
            if(next) {
                this.setSelect(next);
            }
        }
    }
    /**
     * [METHOD*][EDIT] Reomve data row(multi)
     * @param row Data for add row
     */
    removeRows(rows) {
        // 1. append to removes array
        rows.forEach(row => {
            if(row.__dirty === CONST.VAL.DIRTY.FLAG.CREATE) {
                // 1.1 created row
                this.changed.created.find((cRow, idx) => {
                    if(row.__id !== cRow.__id) { return false;}
                    this.changed.created.splice(idx, 1);
                    return true
                });
            } else if(row.__dirty === CONST.VAL.DIRTY.FLAG.UPDATE) {
                // 1.2 updated row
                // 1.2.1 pop from update
                this.changed.updated.find((cRow,idx) => {
                    if(row.__id !== cRow.__id) {return false;}
                    // 2.2.1 pop updated
                    this.changed.updated.splice(idx, 1);
                    return true;
                });
                // 1.2.2 push to removed array
                row.__dirty = CONST.VAL.DIRTY.FLAG.REMOVE;
                this.changed.removed.push(row);
            } else {
                // 1.3 else -> pure delete
                row.__dirty = CONST.VAL.DIRTY.FLAG.REMOVE;
                this.changed.removed.push(row);
            }
        })
        
        // 2. remove to items(origin data)
        // 2.1 make id set(rows)
        var set = new Set(rows.map(r=>r.__id));
        // 2.2 loop orign data
        var nArr = this.rawData.filter(r=>!set.has(r.__id));
        // 3. set to rawData
        // 이래도 되나? 저 밖에서 던져준 Array가 바뀌게 된다.
        this.rawData = nArr;
        this.totalSize = this.rawData.length;
        // 4. post process
        this.rebuildRowIdx();
        // x. emit update.
        this.dataUpdate()
    }
    /**
     * [METHOD][EDIT] Get changed array info.
     */
    getChanged() {
        return this.changed;
    }
    /**
     * [METHOD*][UPDATE] Make dataSet updated
     * This methods only fire redraw grid(or other component)
     */
    emitUpdate(r,field) {
        if(r && r.__compo) {
            // 이게 과연 올바른 일인가?
            // 필요한가? ㅇㅇ
            // 돌아가는가? ㅇㅇ ??
            // 이래도 괜찬흔가? 성능 개선은 어떨까?
            if(field) {
                Vue.set(r.__compo, field, r[field]);
                Vue.set(r.__compo, '__dirty'  , r.__dirty);
                //Vue.set(r.__compo, '__updated', new Date().getTime());
            } else {
                for(var k in r) { // 흐음.. 이게 뭔짓이지? ㅉㅉ
                    if(k==='__compo') continue; 
                    r.__compo[k] = r[k];
                }
            }
        } else {
            Vue.set(this, 'updated', new Date().getTime());
        }
    }
    /**
     * [METHOD*][UPDATE] dataSet updated & build it!
     * This methods makes grid to build data&view data...
     */
    dataUpdate() {
        Vue.set(this, 'dataUpdated', new Date().getTime());
    }
    
    /**
     * [METHOD][INFO] keyField, get keyField
     * @return keyField name
     */
    getKeyField() {return this.keyField;}
    /**
     * [METHOD][INFO] keyField, get select
     * @param keyField String for keyField 
     */
    setKeyField(keyField) {
        // 0. Prepare variable
        var oldKey = this.keyField;
        // 1. Set key
        this.keyField = keyField || this.keyField || null;
        var newKey = this.keyField;
        // 2. build if it needed
        if(oldKey !== newKey) {
            // 2.1 rebuild key
            this.rawData.forEach((row,i)=>{
                row.__id  = getKey(`grid${this.dsIdx}`);
            });
            // 2.2 build map
            this.buildKeyMap()
        }
    }
    
    /**
     * [METHOD][SELECT] Selection, Calculate length of selected array
     * @return Size of selected row array
     */
    updateSelectLength() {
        return this.selLen = this.selected.length;
    }
    /**
     * [METHOD][SELECT] Selection, get select
     * @return Selected row array
     */
    getSelected() {
        //return this.selected;
        return copyArr(this.selected);
    }
    /**
     * [METHOD+][SELECT] Selection, set select
     * @param v ID of select target row
     * @param multi Flag for multi-select
     */
    setSelect(v, multi) {
        // 1. get data
        var row = this.getRow(v.__id);
        if(!row) {
            console.warn("[DATA.SET] Cannot found row data ::", v)
            return;
        }
        // 2. Do toggle!
        if(multi) {
            // 2.1 multi mode
            if(row.__selected) {
                this.selected.find((s,i)=>{
                    if(s !== row) {return false;}
                    this.selected.splice(i,1);
                    return true;
                })
                row.__selected = false;
            } else {
                this.selected.push(row);
                row.__selected = true;
            }
        } else {
            // 2.2 single mode
            let flag = row.__selected;
            this.removeSelected()
            if(flag) {
                row.__selected = false;
            } else {
                this.selected.push(row);
                row.__selected = true;
            }
        }
        this.updateSelectLength()
        this.emitUpdate(row,'__selected');
    }
    /**
     * [METHOD+][SELECT] Selection, remove all selection
     */
    removeSelected() {
        this.selected.forEach(v=> {
            v.__selected = false;
            this.emitUpdate(v,'__selected');
        })
        this.selected = [];
        this.updateSelectLength()
    }
    /**
     * [METHOD+][SELECT] Selection, set select all
     */
    setSelectAll() {
        if(this.isGroup) {
            var arrs = [], me = this;
            (function selectAll(arr){
                arr.forEach(v => {
                    if(v.group) {selectAll(v.children)}
                    else {
                        arrs.push(v);
                        v.__selected = true;
                        me.emitUpdate(v,'__selected');
                    }
                }) 
            })(this.viewData)
            this.selected = arrs;
        } else {
            this.selected = this.viewData.slice(); // shallow copy;
            this.selected.forEach(v=> {
                v.__selected = true;
                this.emitUpdate(v,'__selected');
            })
        }
        this.updateSelectLength()
    }
    /**
     * [METHOD+][SELECT] Selection, set deselect all
     */
    setDeselectAll() {
        this.removeSelected();
    }
    /**
     * [METHOD*][SELECT] Selection, set select range, from - to
     * @param fr ID for from row
     * @param to ID for to row
     * @param append flag for append or not, false make reset previous selection 
     */
    setSelectRange(fr, to, appendFlag) {
        // 1. get row & idx
        let rfr = this.getRow(fr.__id),
            rto = this.getRow(to.__id);
        if(!rfr || !rto) {return;}
        let ifr, ito;
        this.viewData.forEach((r,i)=>{
            if(r === rfr) ifr = i;
            if(r === rto) ito = i;
        })
        let imin = ifr<ito?ifr:ito,
            imax = ifr<ito?ito:ifr;
        // 2. Release selected flag
        if( !appendFlag ) {this.removeSelected()}
        // 3. Make new Array
        let apnd = this.viewData.slice(imin, imax+1);
        apnd.forEach(v=>{
            if(apnd.__selected) {return}
            v.__selected = true;
            this.emitUpdate(v,'__selected');
            this.selected.push(v);
        });
        this.updateSelectLength()
        this.emitUpdate();
    }
    
    /**
     * [METHOD*][SORT][UTIL] Sort data
     * @arr arr Array to sort
     * @param sortArr Field array, object, {sort:[boolean|function], __sortOrder : ['','A','D']
     */
    sortData(arr, sortArr) {
        var me = this;
        if(!sortArr || !sortArr.length) return arr; // need slice?
        // 1. copy data;
        /*var tmpData = arr;*/
        // 2. sorting
        return arr.sort(function(x,y) {
            var rtn = 0, f, v;
            for(var i=0, ii=sortArr.length; rtn === 0 && i<ii ; i++ ) {
                rtn = me.sortComparator(sortArr[i],x,y);
            }
            return rtn;
        })
    }
    /**
     * [METHOD][SORT][UTIL][LOCAL] Sort comparator
     * @f field info
     * @x first value
     * @v second value
     */
    sortComparator(f,x,y,_key) {
        var v = 0, key = _key||f.value, isDesc = 'D' === f.__sortOrder;
        if(f.__isCustomSort) {
            // 2.1 check custom sort
            v = f.sort(x[key], y[key], x, y);
            if(isDesc) v = -v;
        } else {
            // 2.2 default sort : case parsing
            //     Discussion : Switch case - String vs Integer, Enum
            //          https://stackoverflow.com/questions/34571231/javascript-performance-switch-integer-vs-switch-string
            //          int < string, enum(≒ +25%) in Chrome
            //          int, string < enum(≒ +25%) in IE
            //          enum < int(+13%) < string(+23%) in Firefox
            switch(f.type) {
            case 'boolean':
            case 'number':
                // number sort
                v = x[key] - y[key];
                if(isDesc) v = -v;
                break;
            case 'string':
            default :
                // normal sorting
                if(!x[key]) {v=-1;break;}
                if(!y[key]) {v= 1;break;}
                if(x[key] === y[key]) {/*v = 0*/}
                else if(x[key] > y[key]) {v = 1}
                else {v = -1}
                if(isDesc) v = -v;
            }
        }
        // 2.3 decide sort direction
        return v;
    }
    
    /**
     * [METHOD*][FILTER][UTIL] Filter data
     * This function do not use "this" value.
     * @param sortArr Field array, object, {sort:[boolean|function], __sortOrder : ['','A','D']
     * @param append flag for append or not, false make reset previous selection 
     */
    filterData(arr, filterArr) {
        if(!filterArr || !filterArr.length) return arr; // need slice?
        // 1. filter array
        return arr.filter(v => {
            var rtn = true, fils = filterArr;
            for(var i=0, ii=fils.length; i<ii ; i++ ) {
                var fi = fils[i];
                rtn = rtn && fi.checker(v[fi.value], fi.data, v);
            }
            return rtn;
        })
    }
}

export default DataSet;